import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<SettingsObjects::ObjectTypeSetup @model={{@model}} />",{ moduleName: "cio/pods/workspace-settings/objects/new/template.hbs" })